module.exports = __webpack_public_path__ + "images/emoji/walking.e38ea25cd0048a98b02f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/walking.png
// module id = 7dXA
// module chunks = 13